import { observable, set } from 'mobx';

export interface IVideoPoster {
    src: string;
    height: number;
    width: number;
}

export interface IVideoAsset {
    provider: string;
    src: string;
    poster: IVideoPoster;
    position: number;
    alt?: string;
}

export class VideoAsset {
    @observable public provider: string = '';
    @observable public src: string = '';
    @observable public poster: IVideoPoster;
    @observable public position: number;

    public static fromJson(videoAsset?: IVideoAsset): VideoAsset {
        const newVideoAsset = new VideoAsset();
        if (videoAsset) {
            set(newVideoAsset, videoAsset);
        }

        return newVideoAsset;
    }
}
